import clsx from 'clsx'

export default function CircleWhite({ className = undefined }: { className?: string }) {
  return <div className={clsx('w-28 h-28 rounded-full bg-white pointer-events-none', className)} />
}
